// The feature names TypeScript names: the access model's keys (`backend/src/access.ts`). Every
// report and page id is in the generated `app.gen.ts` (`pnpm gen`, platform D147).

/** Production & Routing: both pages, every line edit, adding list values. */
export const FEATURE_ROUTING = "routing";

/** Managers: the order $ value, and editing, retiring, deleting and merging list values. */
export const FEATURE_ROUTING_MANAGER = "routingManager";

/**
 * The Admin page (Divisions): its list and every abbreviation write. The Manager Role's for now
 * (`backend/src/access.ts`); its own group later changes only that file and a `GROUP_*`.
 */
export const FEATURE_ROUTING_ADMIN = "routingAdmin";
